import { createApp } from "vue";
import App from "./App.vue";
import VueRouter from "@/router/index";

const app = createApp(App);
app.use(VueRouter);
app.mount("#app");
